import Axios from "axios";
import {
  SET_LEDGER_REPORT,
  UNSET_LEDGER_REPORT,
} from "@/store/mutation-types";
import {
  getLedgerReport,
} from "@/store/api";

const state = {
  ledgerReport: [],
};

const getters = {
  getLedgerReport(state) {
    return state.ledgerReport;
  },
};

const mutations = {
  [SET_LEDGER_REPORT](state, data) {
    state.ledgerReport = data;
  },
  [UNSET_LEDGER_REPORT](state) {
    state.ledgerReport = [];
  },
};

const actions = {
  getLedger({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getLedgerReport}`, { params: data })
        .then((response) => {
          commit(SET_LEDGER_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_LEDGER_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

